export const NOTIFICATION_MESSAGES = 'NOTIFICATION_MESSAGES';
export const NOTIFICATION_MESSAGES_SUCCESS = 'NOTIFICATION_MESSAGES_SUCCESS';